"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.composeSorterSelector = exports.toSorterSelector = exports.toSorter = exports.nilSorter = void 0;
const isArray_1 = __importDefault(require("lodash/isArray"));
const reduce_1 = __importDefault(require("lodash/reduce"));
const map_1 = __importDefault(require("lodash/map"));
const isPlainObject_1 = __importDefault(require("lodash/isPlainObject"));
const selectors_1 = require("@zedoc/selectors");
const reselect_1 = require("reselect");
const constant = (x) => () => x;
const compose = (f, g) => {
    if (!f) {
        return g;
    }
    if (!g) {
        return f;
    }
    return (a, b) => {
        const value = f(a, b);
        if (value !== 0) {
            return value;
        }
        return g(a, b);
    };
};
const compare = (a, b) => {
    if (a < b) {
        return -1;
    }
    if (a > b) {
        return 1;
    }
    return 0;
};
exports.nilSorter = constant(0);
const createSortByKey = (order, key) => {
    const getKey = (0, selectors_1.createGetAtKey)(key);
    return (a, b) => order * compare(getKey(a), getKey(b));
};
const toSorter = (sorter = exports.nilSorter) => {
    if (typeof sorter === 'function') {
        return sorter;
    }
    if (typeof sorter === 'string') {
        return (0, exports.toSorter)({ [sorter]: 1 });
    }
    if ((0, isArray_1.default)(sorter)) {
        return (0, reduce_1.default)((0, map_1.default)(sorter, exports.toSorter), compose, exports.nilSorter);
    }
    if ((0, isPlainObject_1.default)(sorter)) {
        return (0, exports.toSorter)((0, map_1.default)(sorter, createSortByKey));
    }
    return exports.nilSorter;
};
exports.toSorter = toSorter;
const toSorterSelector = (selector = constant(exports.nilSorter)) => (0, reselect_1.createSelector)((0, selectors_1.toSelector)(selector), exports.toSorter);
exports.toSorterSelector = toSorterSelector;
const composeSorterSelector = (selectSorter, selectAnotherSorter = exports.nilSorter) => {
    if (!selectSorter) {
        return selectAnotherSorter;
    }
    return (0, reselect_1.createSelector)((0, exports.toSorterSelector)(selectSorter), (0, exports.toSorterSelector)(selectAnotherSorter), (sorter, newSorter) => compose(sorter, newSorter));
};
exports.composeSorterSelector = composeSorterSelector;
//# sourceMappingURL=sorting.js.map